module.exports = "https://web-assets.ifttt.com/packs/media/docs/enable-connection-with-trigger-4bbf470d.png";